/*
 * Hammer hook gives functionality to detect user events on give container.
 * Dependency: hammerjs (npm install hammerjs --save)
 *
 * Functionality of hook can be extended by passing single callback for all events
 * and pass type of hook to callback.
 *
 * Callback functions are stored using ref to avoid rerunning of useEffect.
 * This avoid extra work of consumer component
 */

import { useEffect, useRef } from 'react'
import Hammer from 'hammerjs'

const noop = () => {}

export const useHammer = (elRef, options, callbacks) => {
  const { pan = {}, swipe = {}, tap = {}, pinch = {} } = options
  const {
    onSwipeLeft = noop,
    onSwipeRight = noop,
    onPanStart = noop,
    onPanEnd = noop,
    onPinch = noop,
    onDoubleTap = noop,
  } = callbacks

  const swipeLeftRef = useRef()
  swipeLeftRef.current = onSwipeLeft

  const swipeRightRef = useRef()
  swipeRightRef.current = onSwipeRight

  const panStartRef = useRef()
  panStartRef.current = onPanStart

  const panEndRef = useRef()
  panEndRef.current = onPanEnd

  const pinchRef = useRef()
  pinchRef.current = onPinch

  const doubleTapRef = useRef()
  doubleTapRef.current = onDoubleTap

  useEffect(() => {
    if (!elRef || !elRef.current) {
      console.error('UseHammer hook need reference of hammer container')
      return
    }

    const container = elRef.current
    const HammerManager = new Hammer.Manager(container)

    HammerManager.add(new Hammer.Pan(pan))
    HammerManager.add(new Hammer.Swipe(swipe))
    HammerManager.add(new Hammer.Tap(tap))
    HammerManager.add(new Hammer.Pinch())
    HammerManager.get('pinch').set(pinch)

    HammerManager.on('panstart', (e) => panStartRef.current(e))
    HammerManager.on('panend', (e) => panEndRef.current(e))
    HammerManager.on('swipeleft', (e) => swipeLeftRef.current(e))
    HammerManager.on('swiperight', (e) => swipeRightRef.current(e))
    HammerManager.on('doubletap', (e) => doubleTapRef.current(e))
    HammerManager.on('pinch', (e) => pinchRef.current(e))

    return () => {
      HammerManager.off('panstart')
      HammerManager.off('panend')
      HammerManager.off('swipeleft')
      HammerManager.off('swiperight')
      HammerManager.off('doubletap')
      HammerManager.off('pinch')
    }
  }, [panStartRef, panEndRef, swipeLeftRef, swipeRightRef, pinchRef, doubleTapRef])
}
